import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';
import whiteLogo from '../Commissary-Connect.svg';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      // 8px, not 50. The header is TRANSPARENT until this fires, and the hero
      // headline scrolls underneath it, so every pixel of this threshold is a
      // band where white text is drawn straight through the navigation. At 50
      // that band was 50px wide and trivially hit by one trackpad nudge —
      // Jeffrey screenshotted it. It gets worse the shorter the window, because
      // the hero centres its content and a short viewport starts the headline
      // closer to the top. 8px keeps the transparent look at true rest while
      // making the solid background appear the instant anyone scrolls; 8 rather
      // than 0 so macOS rubber-band overscroll does not flicker it.
      setIsScrolled(window.scrollY > 8);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`header ${isScrolled || !isHomePage ? 'header-scrolled' : ''}`}>
      <div className="container">
        <div className="header-content">
          <Link to="/" className="logo">
            <img src={whiteLogo} alt="Commissary Connect" />
          </Link>
          
          <nav id="main-navigation" className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
            <Link to="/" className={location.pathname === '/' ? 'active' : ''} onClick={() => setIsMenuOpen(false)}>Home</Link>
            <Link to="/our-kitchens" className={location.pathname === '/our-kitchens' ? 'active' : ''} onClick={() => setIsMenuOpen(false)}>Our Kitchens</Link>
            <Link to="/members" className={location.pathname === '/members' ? 'active' : ''} onClick={() => setIsMenuOpen(false)}>Our Members</Link>
            <Link to="/story" className={location.pathname === '/story' ? 'active' : ''} onClick={() => setIsMenuOpen(false)}>Our Story</Link>
            <Link to="/faq" className={location.pathname === '/faq' ? 'active' : ''} onClick={() => setIsMenuOpen(false)}>FAQ</Link>
            <a
              href="tel:7785587272"
              className="phone-link"
              data-phone-label="header"
              onClick={() => setIsMenuOpen(false)}
            >
              778.558.7272
            </a>
            <a
              href="/application" 
              data-apply-label="header_apply"
              className="apply-btn" 
              onClick={() => {
                setIsMenuOpen(false);
                if (window.gtag) {
                  window.gtag('event', 'click', {
                    event_category: 'Application',
                    event_label: 'Header Apply Now',
                    value: 1
                  });
                }
              }}
            >
              Apply Now
            </a>
          </nav>
          
          <a href="tel:7785587272" className="header-phone-mobile" data-phone-label="header_bar" aria-label="Call Commissary Connect at 778 558 7272">
            <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" aria-hidden="true"><path d="M6.62 10.79a15.05 15.05 0 006.59 6.59l2.2-2.2a1 1 0 011.01-.24 11.36 11.36 0 003.56.57 1 1 0 011 1V20a1 1 0 01-1 1A17 17 0 013 4a1 1 0 011-1h3.5a1 1 0 011 1 11.36 11.36 0 00.57 3.56 1 1 0 01-.24 1.01l-2.21 2.22z"/></svg>
          </a>

          <button
            className="menu-toggle"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label={isMenuOpen ? "Close navigation menu" : "Open navigation menu"}
            aria-expanded={isMenuOpen}
            aria-controls="main-navigation"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;